import { Link } from "react-router-dom";
import { Mail, MapPin, ShieldCheck, CreditCard } from "lucide-react";
import { useTranslation } from "react-i18next";

// Footer strings now flow through i18n (ES/EN/PT) so language switching
// takes effect across the whole surface, not just the nav.
const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border/30 py-14 bg-card/20">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-10 mb-10">
          <div className="md:col-span-1">
            <Link to="/" className="text-2xl font-heading font-bold text-gradient-rose">BADDY</Link>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed">
              {t("footer.tagline")}
            </p>
            <div className="mt-4 space-y-2 text-xs text-muted-foreground">
              <p className="flex items-start gap-2">
                <MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0" />
                <span>{t("footer.operatedBy")}<br />{t("footer.address")}</span>
              </p>
              <p className="flex items-center gap-2">
                <Mail className="w-3.5 h-3.5 shrink-0" />
                <a href="mailto:hello@joinbaddy.com" className="hover:text-foreground transition-colors">hello@joinbaddy.com</a>
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold mb-3">{t("footer.platformHeading")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/" className="hover:text-foreground transition-colors">{t("footer.home")}</Link></li>
              <li><Link to="/explore" className="hover:text-foreground transition-colors">{t("footer.explore")}</Link></li>
              <li><Link to="/how-it-works" className="hover:text-foreground transition-colors">{t("footer.howItWorks")}</Link></li>
              <li><Link to="/about" className="hover:text-foreground transition-colors">{t("footer.about")}</Link></li>
              <li><Link to="/create" className="hover:text-foreground transition-colors">{t("footer.create")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold mb-3">{t("footer.trustHeading")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/trust" className="hover:text-foreground transition-colors">{t("footer.trustSafety")}</Link></li>
              <li><Link to="/content-policy" className="hover:text-foreground transition-colors">{t("footer.contentPolicy")}</Link></li>
              <li><Link to="/support" className="hover:text-foreground transition-colors">{t("footer.support")}</Link></li>
              <li><a href="mailto:support@joinbaddy.com" className="hover:text-foreground transition-colors">{t("footer.contact")}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold mb-3">{t("footer.legalHeading")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="hover:text-foreground transition-colors">{t("footer.privacy")}</Link></li>
              <li><Link to="/terms" className="hover:text-foreground transition-colors">{t("footer.terms")}</Link></li>
              <li><Link to="/content-policy" className="hover:text-foreground transition-colors">{t("footer.communityGuidelines")}</Link></li>
              <li><Link to="/creator-agreement" className="hover:text-foreground transition-colors">{t("footer.creatorTerms")}</Link></li>
              <li><Link to="/acceptable-use" className="hover:text-foreground transition-colors">{t("footer.acceptableUse")}</Link></li>
              <li><Link to="/dmca" className="hover:text-foreground transition-colors">{t("footer.dmcaPolicy")}</Link></li>
              <li><Link to="/refund" className="hover:text-foreground transition-colors">{t("footer.refundPolicy")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-border/20 flex flex-col gap-4">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-border/50 bg-secondary/40 px-3 py-1 text-[11px] font-semibold text-muted-foreground">
              <ShieldCheck className="w-3.5 h-3.5 text-primary" /> 100% SFW
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-border/50 bg-secondary/40 px-3 py-1 text-[11px] font-semibold text-muted-foreground">
              <CreditCard className="w-3.5 h-3.5 text-primary" /> {t("hero.trustStripe")}
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-border/50 bg-secondary/40 px-3 py-1 text-[11px] font-semibold text-muted-foreground">
              Operated by Nudara Global LLC
            </span>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-xs text-muted-foreground">
            <p>© {year} Nudara Global LLC. All rights reserved.</p>
            <p>{t("footer.paymentsNote")} {t("footer.stripeNotEndorsed")}</p>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
